import { XMLParser } from 'fast-xml-parser';

/**
 * Parse RSS feed XML into episode objects.
 */
export function parseRssFeed(xmlString) {
  const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: '@_'
  });

  const result = parser.parse(xmlString);
  const channel = result.rss?.channel;

  if (!channel) {
    throw new Error('Invalid RSS feed: missing channel element');
  }

  const items = channel.item || [];
  const episodes = (Array.isArray(items) ? items : [items]).map(parseEpisode);

  return {
    title: channel.title || '',
    description: channel.description || '',
    link: channel.link || '',
    image: channel['itunes:image']?.['@_href'] || '',
    episodes
  };
}

function parseEpisode(item) {
  const audioUrl = item.enclosure?.['@_url'] || item.guid || '';
  const episodeId = audioUrl.split('/').pop()?.replace('.mp3', '') || '';
  const hasTranscript = !!item['podcast:transcript'];
  const transcriptUrl = hasTranscript ? item['podcast:transcript']?.['@_url'] : null;
  const humanSummary = item['itunes:subtitle'] || '';
  const feedSummary = item['itunes:summary'] || item.description || '';
  const isAiSummary = /^AI-generated summary\s*:/i.test(feedSummary);

  return {
    id: episodeId,
    title: item['itunes:title'] || item.title || '',
    author: item['itunes:author'] || '',
    subtitle: item['itunes:subtitle'] || '',
    summary: humanSummary || (isAiSummary ? '' : feedSummary),
    aiSummary: isAiSummary
      ? feedSummary.replace(/^AI-generated summary\s*:\s*/i, '').trim()
      : '',
    pubDate: item.pubDate || '',
    duration: item['itunes:duration'] || '',
    url: audioUrl,
    guid: item.guid || '',
    image: item['itunes:image']?.['@_href'] || '',
    explicit: item['itunes:explicit'] === 'yes',
    hasTranscript,
    transcriptUrl
  };
}
